// Unified Integration Script for GangSheet and DTF by Size
var shopID = '69b84c708c8acfd9a4356ff4';
var GSenabledProductList = [10722616017208,10850646458680];
var DTFenabledProductList = [10227991740728];
var UGSenabledProductList = [9549716488504,9652070482232];
var GANGSHEETBUILDER_URL = 'https://gangsheetbuilder.pixelflowdtf.com';
var DTF_APP_URL = 'https://dtfbysize.pixelflowdtf.com';
var UPLOAD_GANGSHEET_URL = "https://uploadgangsheet.pixelflowdtf.com";
/** Public API Gateway base (noserver) — used on /cart to create priced variants for Upload GangSheet */
var PUBLIC_SERVERLESS_API = "https://noserver.pixelflowdtf.com/prod";
var UNIFIED_CART_SYNC_RELOAD_KEY = 'unified_cart_sync_reload';
/** Session/local key for multi-sheet Upload GangSheet checkout (iframe postMessage → cart). UGS-only. */
var UGS_CHECKOUT_BATCH_KEY = 'pixelflow_ugs_checkout_batch';
var UGS_CHECKOUT_BATCH_TTL_MS = 5 * 60 * 1000;

function saveUgsCheckoutBatch(sheets) {
  var payload = JSON.stringify({ sheets: sheets, ts: Date.now() });
  try { sessionStorage.setItem(UGS_CHECKOUT_BATCH_KEY, payload); } catch (_) { /* ignore */ }
  try { localStorage.setItem(UGS_CHECKOUT_BATCH_KEY, payload); } catch (_) { /* ignore */ }
}

function readUgsCheckoutBatch(consume) {
  var raw = null;
  try { raw = sessionStorage.getItem(UGS_CHECKOUT_BATCH_KEY); } catch (_) { /* ignore */ }
  if (!raw) {
    try { raw = localStorage.getItem(UGS_CHECKOUT_BATCH_KEY); } catch (_) { /* ignore */ }
  }
  if (!raw) return [];
  try {
    var parsed = JSON.parse(raw);
    var sheets = Array.isArray(parsed) ? parsed : (parsed && Array.isArray(parsed.sheets) ? parsed.sheets : []);
    var ts = parsed && parsed.ts ? Number(parsed.ts) : Date.now();
    if (ts && (Date.now() - ts) > UGS_CHECKOUT_BATCH_TTL_MS) {
      clearUgsCheckoutBatch();
      return [];
    }
    if (consume) clearUgsCheckoutBatch();
    return sheets;
  } catch (_) {
    return [];
  }
}

function clearUgsCheckoutBatch() {
  try { sessionStorage.removeItem(UGS_CHECKOUT_BATCH_KEY); } catch (_) { /* ignore */ }
  try { localStorage.removeItem(UGS_CHECKOUT_BATCH_KEY); } catch (_) { /* ignore */ }
}

// Upload GangSheet iframe (cross-origin) can stash multiple sheets then navigate parent to /cart.
(function installUgsCheckoutBatchListener() {
  if (typeof window === 'undefined' || window.__pixelflowUgsBatchListener) return;
  window.__pixelflowUgsBatchListener = true;
  window.addEventListener('message', function (event) {
    try {
      var data = event && event.data;
      if (!data || data.type !== 'pixelflow_ugs_checkout_batch') return;
      if (!Array.isArray(data.sheets) || !data.sheets.length) return;
      // Only accept messages that look like Upload GangSheet payloads (never GS/DTF).
      var looksLikeUgs = data.sheets.every(function (s) {
        return s && (s.uploadGangsheetKey || s.fileUrl || s.id) && s.price != null && s.shopId && s.baseProductId;
      });
      if (!looksLikeUgs) {
        console.warn('[Unified] Ignored ugs checkout batch — payload failed validation');
        return;
      }
      saveUgsCheckoutBatch(data.sheets);
      try {
        if (event.source && typeof event.source.postMessage === 'function') {
          event.source.postMessage({ type: 'pixelflow_ugs_checkout_batch_ack', ok: true }, event.origin || '*');
        }
      } catch (_) { /* ignore */ }
      if (data.navigateUrl && typeof data.navigateUrl === 'string') {
        window.location.href = data.navigateUrl;
      }
    } catch (err) {
      console.warn('[Unified] ugs checkout batch listener error:', err);
    }
  });
})();

// Reload /cart once right after builder redirect so theme HTML picks up variant prices (Ajax cart is often ahead).
(function unifiedCartEarlyPriceSync() {
  try {
    var path = window.location.pathname || '';
    if (path.indexOf('/cart') === -1) return;
    var search = window.location.search || '';
    if (search.indexOf('items=') !== -1) return;
    if (sessionStorage.getItem(UNIFIED_CART_SYNC_RELOAD_KEY) === '1') {
      sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '2');
      window.location.reload();
    }
  } catch (_) { /* ignore */ }
})();

// Helper: Normalize product ID for comparison
function normalizeProductId(id) {
  if (typeof id === 'string') {
    const num = parseInt(id, 10);
    return isNaN(num) ? id : num;
  }
  return id;
}

// Helper: Check if product is in list (handles all type variations)
function isProductInList(productId, productList) {
  const normalizedId = normalizeProductId(productId);
  const normalizedList = productList.map(id => normalizeProductId(id));
  
  return normalizedList.includes(normalizedId) || 
         normalizedList.some(id => String(id) === String(normalizedId)) ||
         normalizedList.some(id => Number(id) === Number(normalizedId));
}

// Format DTF-by-size images array as readable text for Shopify admin order view
function formatDtfBySizeImagesAsText(dtfImages) {
  if (!Array.isArray(dtfImages) || dtfImages.length === 0) return '';
  return dtfImages.map(function (im, idx) {
    const w = im.w != null ? Number(im.w) : 0;
    const h = im.h != null ? Number(im.h) : 0;
    const qty = im.qty != null ? Number(im.qty) : 1;
    const url = (im.url || '').trim();
    const line1 = 'Image ' + (idx + 1) + ': ' + w.toFixed(2) + '" x ' + h.toFixed(2) + '" (Qty: ' + qty + ')';
    return url ? line1 + '\n' + url : line1;
  }).join('\n\n');
}

function showUnifiedCartUpdatingOverlay() {
  if (document.getElementById('unified-cart-updating-overlay')) return;
  if (!document.getElementById('unified-cart-overlay-style')) {
    var st = document.createElement('style');
    st.id = 'unified-cart-overlay-style';
    st.textContent = '@keyframes unifiedCartSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);
  }
  var el = document.createElement('div');
  el.id = 'unified-cart-updating-overlay';
  el.setAttribute('aria-busy', 'true');
  el.style.cssText = 'position:fixed;inset:0;z-index:2147483646;background:rgba(255,255,255,0.94);display:flex;align-items:center;justify-content:center;flex-direction:column;font-family:system-ui,-apple-system,sans-serif;';
  var spinner = document.createElement('div');
  spinner.style.cssText = 'width:40px;height:40px;border:3px solid #e8e8e8;border-top-color:#111;border-radius:50%;animation:unifiedCartSpin 0.75s linear infinite';
  var msg = document.createElement('p');
  msg.style.cssText = 'margin-top:18px;color:#222;font-size:15px;max-width:90%;text-align:center';
  msg.textContent = 'Updating your cart…';
  el.appendChild(spinner);
  el.appendChild(msg);
  document.body.appendChild(el);
}

function hideUnifiedCartUpdatingOverlay() {
  var el = document.getElementById('unified-cart-updating-overlay');
  if (el) el.remove();
}

function unifiedSleep(ms) {
  return new Promise(function (resolve) { setTimeout(resolve, ms); });
}

function unifiedLinePriceCents(line) {
  if (!line) return 0;
  var keys = ['final_line_price', 'line_price', 'original_line_price', 'discounted_price'];
  for (var k = 0; k < keys.length; k++) {
    var v = line[keys[k]];
    if (v == null) continue;
    var n = Number(v);
    if (!isNaN(n) && n > 0) return n;
  }
  var p = line.price;
  if (p != null) {
    var pn = Number(p);
    if (!isNaN(pn) && pn > 0) {
      // Some responses use dollars as decimal string; cart.js normally uses cents (integer)
      if (pn < 500 && (String(p).indexOf('.') >= 0 || pn < 50)) {
        return Math.round(pn * 100);
      }
      return pn;
    }
  }
  return 0;
}

/**
 * New Admin-created variants are often rejected by /cart/add.js (422 sold out) until storefront catches up.
 * Retries with backoff mimic the delay users get when pausing in a debugger.
 */
async function unifiedCartAddWithRetries(items) {
  var root = window.Shopify.routes.root;
  var maxAttempts = 12;
  var betweenDelays = [400, 550, 750, 1000, 1300, 1700, 2100, 2600, 3200, 4000, 5000];
  var lastResult;
  var lastResponse;
  for (var a = 0; a < maxAttempts; a++) {
    if (a > 0) await unifiedSleep(betweenDelays[a - 1] || 3000);
    lastResponse = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    lastResult = await lastResponse.json();
    if (lastResponse.ok) {
      return { ok: true, result: lastResult, response: lastResponse };
    }
    var msg = ((lastResult && (lastResult.message || lastResult.description)) || '').toLowerCase();
    var retryable = lastResponse.status === 422 && (
      msg.indexOf('sold out') >= 0 ||
      msg.indexOf('out of stock') >= 0 ||
      msg.indexOf('unavailable') >= 0 ||
      msg.indexOf('not available') >= 0 ||
      msg.indexOf('could not be added') >= 0
    );
    if (!retryable || a === maxAttempts - 1) {
      return { ok: false, result: lastResult, response: lastResponse };
    }
    console.warn('[Unified] cart/add.js retry ' + (a + 2) + '/' + maxAttempts + ':', lastResult.message || lastResult.description);
  }
  return { ok: false, result: lastResult, response: lastResponse };
}

/**
 * Create dynamic Shopify variant via serverless (same Lambda as GangSheet / DTF-by-size apps).
 * Retries transient failures; does not retry 400/404/422 validation errors.
 */
async function unifiedCreateVariantCheckoutWithRetries(ugs) {
  var apiBase = (typeof PUBLIC_SERVERLESS_API !== 'undefined' && PUBLIC_SERVERLESS_API)
    ? String(PUBLIC_SERVERLESS_API).replace(/\/$/, '')
    : '';
  if (!apiBase) {
    return { ok: false, error: 'Serverless API URL not configured' };
  }
  var url = apiBase + '/shopify/create-variant-checkout';
  var basePid = ugs.baseProductId;
  if (typeof basePid === 'string') basePid = parseInt(basePid, 10);
  if (isNaN(basePid)) {
    return { ok: false, error: 'Invalid baseProductId' };
  }
  var body = {
    size: ugs.size || 'Upload',
    quantity: ugs.quantity || 1,
    price: ugs.price,
    shopId: String(ugs.shopId || ''),
    baseProductId: basePid,
    uploadGangsheetKey: String(ugs.uploadGangsheetKey || ugs.id || '')
  };
  var maxAttempts = 10;
  var betweenDelays = [400, 550, 750, 1000, 1300, 1700, 2100, 2600, 3200, 4000];
  var lastErr = '';
  for (var a = 0; a < maxAttempts; a++) {
    if (a > 0) await unifiedSleep(betweenDelays[a - 1] || 3000);
    try {
      var resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      var lastResult = await resp.json().catch(function () { return {}; });
      if (resp.ok && lastResult && lastResult.success && lastResult.variantId) {
        return { ok: true, variantId: lastResult.variantId };
      }
      lastErr = (lastResult && lastResult.error) ? String(lastResult.error) : ('HTTP ' + resp.status);
      if (resp.status === 400 || resp.status === 404 || resp.status === 422) {
        return { ok: false, error: lastErr };
      }
      console.warn('[Unified] create-variant-checkout attempt ' + (a + 1) + '/' + maxAttempts + ':', lastErr);
    } catch (e) {
      lastErr = e && e.message ? e.message : String(e);
      console.warn('[Unified] create-variant-checkout fetch error:', lastErr);
    }
  }
  return { ok: false, error: lastErr || 'Variant creation failed' };
}

/**
 * Storefront cart can show $0 until variant price propagates; poll until line prices are non-zero (cents).
 */
async function unifiedWaitForCartLinePrices(variantIds, timeoutMs) {
  var root = window.Shopify.routes.root;
  var ids = variantIds.map(function (v) { return String(v); });
  var deadline = Date.now() + (timeoutMs || 15000);
  while (Date.now() < deadline) {
    try {
      var cartRes = await fetch(root + 'cart.js');
      var cart = await cartRes.json();
      var cartItems = cart.items || [];
      var allOk = true;
      for (var i = 0; i < ids.length; i++) {
        var line = null;
        for (var j = 0; j < cartItems.length; j++) {
          if (String(cartItems[j].variant_id) === ids[i]) {
            line = cartItems[j];
            break;
          }
        }
        if (!line) {
          allOk = false;
          break;
        }
        if (!(unifiedLinePriceCents(line) > 0)) {
          allOk = false;
          break;
        }
      }
      if (allOk) return;
    } catch (e) {
      console.warn('[Unified] waitForCartLinePrices:', e);
    }
    await unifiedSleep(280);
  }
  console.warn('[Unified] Proceeding to /cart before prices propagated (may show $0 briefly)');
}

// Tinker/Horizon uses .product-form-buttons (hyphen). Dawn/OS2 uses .product-form__buttons (BEM).
var PIXELFLOW_CUSTOM_BTN_SEL = '.my-custom-add-button, .dtf-custom-upload-button, .ugs-custom-upload-button';
var PIXELFLOW_INSERT_CONTAINERS = [
  '.product-form-buttons',
  '[ref="productFormButtons"]',
  '.product-form__buttons',
  '.product-form__buttons-wrapper',
  '.product__buttons',
  '.product-single__form',
  '.buy-buttons-block',
  'product-form-component'
].join(', ');
var PIXELFLOW_NATIVE_BUY_STYLE_ID = 'pixelflow-hide-native-buy-style';

function queryProductAddForms() {
  return document.querySelectorAll(
    'form[action="/cart/add"], form[action$="/cart/add"], form[data-type="add-to-cart-form"], form.shopify-product-form'
  );
}

function getPageProductId() {
  if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
    return normalizeProductId(ShopifyAnalytics.meta.product.id);
  }
  return null;
}

function getFormProductId(form) {
  if (!form) return null;
  var input = form.querySelector('input[name="product-id"], input[name="product_id"], [name="product-id"]');
  if (input && input.value) return normalizeProductId(input.value);
  if (form.dataset && (form.dataset.productId || form.dataset.productid)) {
    return normalizeProductId(form.dataset.productId || form.dataset.productid);
  }
  var host = form.closest('[data-product-id], product-form-component');
  if (host && host.dataset && (host.dataset.productId || host.dataset.productid)) {
    return normalizeProductId(host.dataset.productId || host.dataset.productid);
  }
  return null;
}

function isRelatedProductCardForm(form) {
  return !!(form && form.closest && form.closest(
    'product-card, .product-card, .card-wrapper, .card__content, .quick-add, .quick-add-modal'
  ));
}

function ensureNativeBuyButtonsHiddenStyle() {
  if (document.getElementById(PIXELFLOW_NATIVE_BUY_STYLE_ID)) return;
  var st = document.createElement('style');
  st.id = PIXELFLOW_NATIVE_BUY_STYLE_ID;
  st.textContent = [
    '.pixelflow-custom-cta add-to-cart-component,',
    '.pixelflow-custom-cta .add-to-cart-button,',
    '.pixelflow-custom-cta button[type="submit"]:not(.my-custom-add-button):not(.dtf-custom-upload-button):not(.ugs-custom-upload-button),',
    '.pixelflow-custom-cta input[type="submit"],',
    '.pixelflow-custom-cta .product-form__submit,',
    '.pixelflow-custom-cta .product-form-buttons > span:has(add-to-cart-component),',
    '.pixelflow-custom-cta .product-form-buttons > span:has(.add-to-cart-button),',
    '.pixelflow-custom-cta .accelerated-checkout-block,',
    '.pixelflow-custom-cta [data-shopify="payment-button"],',
    '.pixelflow-custom-cta .shopify-payment-button,',
    '.pixelflow-custom-cta shopify-accelerated-checkout,',
    '.pixelflow-custom-cta more-payment-options-link,',
    '.pixelflow-custom-cta .shopify-payment-button__more-options,',
    '.pixelflow-custom-cta .additional-checkout-buttons,',
    '.pixelflow-custom-cta .sticky-add-to-cart__button {',
    '  display: none !important;',
    '}',
    '.product-form-buttons > .my-custom-add-button,',
    '.product-form-buttons > .dtf-custom-upload-button,',
    '.product-form-buttons > .ugs-custom-upload-button {',
    '  flex: 1 1 100%;',
    '  min-width: 100%;',
    '  width: 100%;',
    '  display: block;',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(st);
}

function markNativeBuyButtonsHidden(form) {
  ensureNativeBuyButtonsHiddenStyle();
  if (form && form.classList) form.classList.add('pixelflow-custom-cta');
  var host = form && form.closest
    ? form.closest('product-form-component, .buy-buttons-block, sticky-add-to-cart')
    : null;
  if (host && host.classList) host.classList.add('pixelflow-custom-cta');
  document.querySelectorAll('sticky-add-to-cart').forEach(function (el) {
    el.classList.add('pixelflow-custom-cta');
  });
}

function getButtonInsertContainer(container) {
  if (!container || !container.querySelector) return container;
  return container.querySelector(PIXELFLOW_INSERT_CONTAINERS) || container;
}

function insertCustomActionButton(container, className, label) {
  var scope = (container.closest && container.closest('form')) || container;
  if ((scope && scope.querySelector('.' + className)) || container.querySelector('.' + className)) {
    return;
  }

  var customBtn = document.createElement('button');
  customBtn.type = 'button';
  customBtn.innerText = label;
  customBtn.className = className;
  customBtn.style.cssText = [
    'width: 100%',
    'padding: 12px',
    'background: #000',
    'color: #fff',
    'font-size: 16px',
    'border: none',
    'border-radius: 6px',
    'cursor: pointer',
    'margin-top: 10px',
    'flex: 1 1 100%',
    'min-width: 100%',
    'display: block'
  ].join(';');

  getButtonInsertContainer(container).appendChild(customBtn);
}

function insertGangSheetButton(container) {
  insertCustomActionButton(container, 'my-custom-add-button', 'Build your GangSheet');
}

function insertDtfButton(container) {
  insertCustomActionButton(container, 'dtf-custom-upload-button', 'Upload your Designs');
}

function insertUploadGangsheetButton(container) {
  insertCustomActionButton(container, 'ugs-custom-upload-button', 'Upload your GangSheet');
}

function getEnabledProductType(productId) {
  if (productId == null) return null;
  const normalizedId = normalizeProductId(productId);
  if (isProductInList(normalizedId, GSenabledProductList)) return 'gs';
  if (isProductInList(normalizedId, DTFenabledProductList)) return 'dtf';
  if (isProductInList(normalizedId, UGSenabledProductList)) return 'ugs';
  return null;
}

function insertButtonForProductType(container, productType) {
  if (productType === 'gs') {
    insertGangSheetButton(container);
  } else if (productType === 'dtf') {
    insertDtfButton(container);
  } else if (productType === 'ugs') {
    insertUploadGangsheetButton(container);
  }
}

// Replace button based on product type
async function replaceWithCustomButton() {
  console.log("[Unified] replaceWithCustomButton called");
  const forms = queryProductAddForms();
  console.log("[Unified] Found", forms.length, "forms");

  const pageProductId = getPageProductId();

  forms.forEach((form) => {
    if (isRelatedProductCardForm(form)) return;

    const formProductId = getFormProductId(form);
    const productId = formProductId || pageProductId;
    if (formProductId && pageProductId && String(formProductId) !== String(pageProductId)) {
      return;
    }

    const productType = getEnabledProductType(productId);
    if (!productType) {
      if (!productId) console.log('[Unified] Could not determine product ID, keeping default button');
      return;
    }

    // Hide ATC / Shop Pay with CSS. Do not remove nodes — Tinker/Horizon web
    // components (add-to-cart-component, quantity-selector-component) crash or
    // remorph when required refs are deleted, which also deletes our button.
    markNativeBuyButtonsHidden(form);

    if (form.querySelector(PIXELFLOW_CUSTOM_BTN_SEL)) {
      return;
    }

    console.log("[Unified] Product ID:", productId, "type:", productType, "— inserting app button");
    insertButtonForProductType(form, productType);
  });

  // Handle GangSheet uploader products
  const gsWrapper = document.querySelector('.gs--wrapper .gs-uploader-wrapper');
  if (gsWrapper) {
    const uploaderBtn = gsWrapper.querySelector('#gs-uploader-btn');
    if (uploaderBtn) uploaderBtn.remove();

    const gsAddBtn = gsWrapper.querySelector('#gs-add-cart-btn');
    if (gsAddBtn) gsAddBtn.remove();

    insertGangSheetButton(gsWrapper);
  }
}

// Main runner function
async function runner() {
  const pathname = window.location.pathname;
  if (pathname.includes('/products/')) {
    // Wait for ShopifyAnalytics to be available
    let retries = 0;
    const maxRetries = 10;
    
    while (retries < maxRetries) {
      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        const product = ShopifyAnalytics.meta.product;
        let productId = product.id;
        
        if (typeof productId === 'string') {
          productId = parseInt(productId, 10);
        }
        
        if (isNaN(productId)) {
          console.error("[Unified] Invalid product ID:", product.id);
          return;
        }
        
        console.log("[Unified] Product ID:", productId, "Type:", typeof productId);
        console.log("[Unified] GSenabledProductList:", GSenabledProductList, "Length:", GSenabledProductList.length);
        console.log("[Unified] DTFenabledProductList:", DTFenabledProductList, "Length:", DTFenabledProductList.length);
        
        const normalizedId = normalizeProductId(productId);
        const isGangSheet = isProductInList(normalizedId, GSenabledProductList);
        const isDtf = isProductInList(normalizedId, DTFenabledProductList);
        const isUgs = isProductInList(normalizedId, UGSenabledProductList);
        
        console.log("[Unified] Is GangSheet enabled?", isGangSheet);
        console.log("[Unified] Is DTF enabled?", isDtf);
        console.log("[Unified] Is Upload GangSheet enabled?", isUgs);
        
        if (isGangSheet || isDtf || isUgs) {
          console.log("[Unified] Product is enabled, replacing button");
          await replaceWithCustomButton();
          installProductButtonObserver();
          return;
        } else {
          console.log("[Unified] Product not in enabled lists:", productId);
          return;
        }
      }
      
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, 200));
      retries++;
    }
    
    console.log("[Unified] ShopifyAnalytics not available after", maxRetries, "retries — trying form product-id");
    await replaceWithCustomButton();
    installProductButtonObserver();
  } else if (pathname === '/cart' || pathname.includes('/cart')) {
    // Handle Shopify cart permalink: /cart/{variantId}:{qty} or /cart/123:1,456:2 (supports /en/cart/... etc)
    // Each GET to this URL adds items server-side, so refresh duplicates. Redirect to /cart immediately.
    const cartPermalinkMatch = pathname.match(/\/cart\/(\d+:\d+(,\d+:\d+)*)$/);
    if (cartPermalinkMatch) {
      const permalinkPath = pathname;
      const cartBasePath = pathname.split('/cart')[0] || '';
      const cleanCartUrl = cartBasePath + '/cart';
      const PERMALINK_KEY = 'unified_cart_permalink';
      const TTL_MS = 2 * 60 * 1000;
      try {
        const stored = localStorage.getItem(PERMALINK_KEY);
        if (stored) {
          const { path, ts } = JSON.parse(stored);
          if (path === permalinkPath && (Date.now() - ts) < TTL_MS) {
            console.log('[Unified] Cart permalink already processed, redirecting to /cart');
            window.location.replace(cleanCartUrl);
            return;
          }
        }
        localStorage.setItem(PERMALINK_KEY, JSON.stringify({ path: permalinkPath, ts: Date.now() }));
      } catch (_) { /* ignore */ }
      window.location.replace(cleanCartUrl);
      return;
    }

    // Handle cart page for GangSheet (adding items from builder)
    const urlParams = new URLSearchParams(window.location.search);
    let oldVariantId = urlParams.get('oldVariantId');
    let addedItemsParam = urlParams.get('items');
    const source = urlParams.get('source'); // 'dtfbysize' = DTF by Size app, else GangSheet

    // Upload GangSheet app: /cart?ugsCheckout=...&source=uploadgangsheet_prepare
    // Supports one object OR an array of sheets (multi-sheet). Also ugsMulti=1 + sessionStorage batch from iframe postMessage.
    // Does NOT touch GangSheet builder (?items=) or DTF-by-size paths.
    const ugsCheckoutParam = urlParams.get('ugsCheckout');
    const ugsMultiFlag = urlParams.get('ugsMulti') === '1';
    if (source === 'uploadgangsheet_prepare' && (ugsCheckoutParam || ugsMultiFlag)) {
      if (window.__unifiedCartAddInProgress) {
        console.log('[Unified] Cart add already in progress, skipping');
        return;
      }
      window.__unifiedCartAddInProgress = true;

      const STORAGE_KEY = 'unified_cart_add';
      const TTL_MS = 2 * 60 * 1000;
      var dedupePayload = ugsCheckoutParam || (ugsMultiFlag ? ('multi:' + (sessionStorage.getItem(UGS_CHECKOUT_BATCH_KEY) || '')) : '');
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.payload === dedupePayload && (Date.now() - parsed.ts) < TTL_MS) {
            console.log('[Unified] Same Upload GangSheet checkout already processed recently, skipping');
            window.__unifiedCartAddInProgress = false;
            const skipUrl = window.location.pathname;
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, document.title, skipUrl);
            }
            try {
              sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '1');
            } catch (_) { /* ignore */ }
            window.location.replace(skipUrl);
            return;
          }
        }
      } catch (_) { /* ignore */ }

      const cleanUrl = window.location.pathname;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, cleanUrl);
      }

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          payload: dedupePayload,
          ts: Date.now()
        }));
      } catch (_) { /* ignore */ }

      let ugsList = [];
      try {
        // Prefer URL payload (single object or array). Fall back to stashed multi-sheet batch.
        if (ugsCheckoutParam) {
          var parsedUgs = JSON.parse(ugsCheckoutParam);
          ugsList = Array.isArray(parsedUgs) ? parsedUgs : [parsedUgs];
        }
        if (!ugsList.length && ugsMultiFlag) {
          // Do not consume yet — only clear after sheets are successfully added (avoids empty reload race).
          ugsList = readUgsCheckoutBatch(false);
        }
      } catch (parseErr) {
        console.error('[Unified] Invalid ugsCheckout JSON:', parseErr);
        window.__unifiedCartAddInProgress = false;
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (_) { /* ignore */ }
        return;
      }

      if (!ugsList.length) {
        console.error('[Unified] Upload GangSheet checkout: no sheets in payload');
        window.__unifiedCartAddInProgress = false;
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (_) { /* ignore */ }
        clearUgsCheckoutBatch();
        return;
      }

      showUnifiedCartUpdatingOverlay();

      try {
        var addedVariantIds = [];
        var removedPlaceholder = false;

        for (var sheetIdx = 0; sheetIdx < ugsList.length; sheetIdx++) {
          var ugs = ugsList[sheetIdx];
          if (!ugs) continue;

          const createOutcome = await unifiedCreateVariantCheckoutWithRetries(ugs);
          if (!createOutcome.ok || !createOutcome.variantId) {
            hideUnifiedCartUpdatingOverlay();
            window.__unifiedCartAddInProgress = false;
            try {
              localStorage.removeItem(STORAGE_KEY);
            } catch (_) { /* ignore */ }
            console.error('[Unified] Upload GangSheet variant creation failed (sheet ' + (sheetIdx + 1) + '):', createOutcome.error);
            return;
          }

          const newVariantId = createOutcome.variantId;

          if (!removedPlaceholder && oldVariantId && oldVariantId !== 'undefined' && oldVariantId !== 'null' && oldVariantId !== '') {
            let cart;
            try {
              const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
              cart = await cartRes.json();
            } catch (err) {
              console.error('Error fetching cart:', err);
              cart = { items: [] };
            }

            const removalPromises = (cart.items || [])
              .filter(item => String(item.variant_id) === String(oldVariantId) && !(item.properties && (item.properties.canvasId || item.properties.dtfbysizesheetId || item.properties.uploadGangsheetKey)))
              .map(item => {
                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                  })
                }).catch(function (error) {
                  console.error('Error updating cart for key', item.key, error);
                });
              });
            if (removalPromises.length > 0) {
              await Promise.all(removalPromises);
              await unifiedSleep(350);
            }
            removedPlaceholder = true;
          }

          const qty = parseInt(ugs.quantity, 10) || 1;
          const timestamp = new Date().getTime();
          const readableTime = new Date(timestamp).toLocaleString();
          const uploadKey = ugs.uploadGangsheetKey || ugs.id || ('ugs-' + timestamp);
          const baseProps = {
            _timestamp: timestamp,
            'Created At': readableTime,
            unique_key: String(newVariantId) + '_' + String(timestamp),
            uploadGangsheetKey: String(uploadKey),
            _upload_gs_file_url: (ugs.fileUrl || '').trim(),
            _upload_gs_preview_url: (ugs.previewUrl || ugs.thumbnailUrl || '').trim(),
            _upload_gs_size: (ugs.size || '').trim(),
            _upload_gs_dimensions: (ugs.dimensions || '').trim(),
            _upload_gs_price_display: (ugs.priceDisplay || '').trim(),
            _upload_gs_sheet_index: String(sheetIdx + 1),
            portalURL: UPLOAD_GANGSHEET_URL + '/?shopId=' + encodeURIComponent(String(ugs.shopId || '')) + '&productId=' + encodeURIComponent(String(ugs.baseProductId || '')) + '&variantId=' + encodeURIComponent(String(newVariantId))
          };

          const items = [{
            id: newVariantId,
            quantity: qty,
            properties: baseProps
          }];

          await unifiedSleep(sheetIdx === 0 ? 300 : 200);

          var addOutcomeUgs = await unifiedCartAddWithRetries(items);
          if (!addOutcomeUgs.ok) {
            hideUnifiedCartUpdatingOverlay();
            window.__unifiedCartAddInProgress = false;
            try {
              localStorage.removeItem(STORAGE_KEY);
            } catch (_) { /* ignore */ }
            console.error('[Unified] Upload GangSheet cart add failed (sheet ' + (sheetIdx + 1) + '):', addOutcomeUgs.result);
            return;
          }

          addedVariantIds.push(String(newVariantId));
        }

        if (!addedVariantIds.length) {
          hideUnifiedCartUpdatingOverlay();
          window.__unifiedCartAddInProgress = false;
          try {
            localStorage.removeItem(STORAGE_KEY);
          } catch (_) { /* ignore */ }
          console.error('[Unified] Upload GangSheet: no variants added');
          return;
        }

        await unifiedWaitForCartLinePrices(addedVariantIds, 20000);
        clearUgsCheckoutBatch();
        try {
          sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '1');
        } catch (_) { /* ignore */ }
        window.__unifiedCartAddInProgress = false;
        window.location.replace(cleanUrl);
      } catch (error) {
        hideUnifiedCartUpdatingOverlay();
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (_) { /* ignore */ }
        console.error('[Unified] Upload GangSheet cart error:', error);
        window.__unifiedCartAddInProgress = false;
      }
      return;
    }

    // Theme HTML can lag Ajax cart; IIFE above reloads when possible — runner repeats if script loaded late.
    if (!addedItemsParam) {
      try {
        var syncRel = sessionStorage.getItem(UNIFIED_CART_SYNC_RELOAD_KEY);
        if (syncRel === '1') {
          sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '2');
          window.location.reload();
          return;
        }
        if (syncRel === '2') {
          sessionStorage.removeItem(UNIFIED_CART_SYNC_RELOAD_KEY);
        }
      } catch (_) { /* ignore */ }
    }

    // Process when we have items to add (oldVariantId optional - e.g. UV/autoroll may not have previous variant)
    if (addedItemsParam) {
      // Guard: prevent concurrent cart-add runs (race when multiple runner() calls start before redirect)
      if (window.__unifiedCartAddInProgress) {
        console.log('[Unified] Cart add already in progress, skipping');
        return;
      }
      window.__unifiedCartAddInProgress = true;

      // Guard: prevent re-adding same items on refresh, back button, or across multiple tabs.
      // localStorage is used (not sessionStorage) so the guard is shared across all tabs for the same origin.
      const STORAGE_KEY = 'unified_cart_add';
      const TTL_MS = 2 * 60 * 1000; // 2 minutes
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const { payload, ts } = JSON.parse(stored);
          if (payload === addedItemsParam && (Date.now() - ts) < TTL_MS) {
            console.log('[Unified] Same items already added recently, skipping');
            window.__unifiedCartAddInProgress = false;
            const cleanUrl = window.location.pathname;
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, document.title, cleanUrl);
            }
            try {
              sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '1');
            } catch (_) { /* ignore */ }
            window.location.replace(cleanUrl);
            return;
          }
        }
      } catch (_) { /* ignore */ }

      // Clear items from URL immediately so any other runner() won't see them
      const cleanUrl = window.location.pathname;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, cleanUrl);
      }

      // Write the dedup key now (before any fetch) so that any concurrent tab or race condition
      // that loads the same ?items= URL is blocked immediately. Since the URL is already cleared
      // above, a fetch failure cannot be retried via the same URL — the user must rebuild on the
      // product page, which generates a new payload and a new canvasId, bypassing this guard.
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          payload: addedItemsParam,
          ts: Date.now()
        }));
      } catch (_) { /* ignore */ }

      let addedItems;
      try {
        addedItems = JSON.parse(addedItemsParam);
      } catch (parseError) {
        console.error('Error parsing items parameter:', parseError);
        window.__unifiedCartAddInProgress = false;
        return; // Exit if items can't be parsed
      }
      if (!Array.isArray(addedItems) || addedItems.length === 0) {
        window.__unifiedCartAddInProgress = false;
        return;
      }

      showUnifiedCartUpdatingOverlay();

      let cart;
      try {
        const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
        cart = await cartRes.json();
      } catch (err) {
        console.error('Error fetching cart:', err);
        cart = { items: [] };
      }

      // Remove old variant items only when oldVariantId is present and not placeholder
      if (oldVariantId && oldVariantId !== 'undefined' && oldVariantId !== 'null') {
        const removalPromises = cart.items
          .filter(item => String(item.variant_id) === String(oldVariantId) && !(item.properties && (item.properties.canvasId || item.properties.dtfbysizesheetId)))
          .map(item => {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            }).catch(error => {
              console.error('Error updating cart for key', item.key, error);
            });
          });
        if (removalPromises.length > 0) {
          await Promise.all(removalPromises);
          await unifiedSleep(350);
        }
      }

      // Now add new items - use dtfbysizesheetId for DTF by Size, canvasId/portalURL for GangSheet
      const isDtfBySize = source === 'dtfbysize';
      let items = [];
      for (let i = 0; i < parseInt(addedItems.length); i++) {
          const timestamp = new Date().getTime() + i * 1000;
          const readableTime = new Date(timestamp).toLocaleString();
          const baseProps = {
            _timestamp: timestamp,
            'Created At': readableTime,
            unique_key: `${addedItems[i].variantId}_${timestamp}`
          };
          if (isDtfBySize) {
            const dtfImages = addedItems[i].images || [];
            const props = {
              ...baseProps,
              dtfbysizesheetId: addedItems[i].id
            };
            if (dtfImages.length > 0) {
              // Human-readable text for Shopify admin and cart (no JSON property sent)
              props._dtfbysize_images = formatDtfBySizeImagesAsText(dtfImages);
            }
            items.push({
              id: addedItems[i].variantId,
              quantity: addedItems[i].quantity,
              properties: props
            });
          } else {
            items.push({
              id: addedItems[i].variantId,
              quantity: addedItems[i].quantity,
              properties: {
                ...baseProps,
                canvasId: addedItems[i].id,
                portalURL: GANGSHEETBUILDER_URL + '/load?canvasId=' + addedItems[i].id
              }
            });
          }
      }

      var variantIdsForPoll = items.map(function (it) { return String(it.id); });

      try {
        await unifiedSleep(300);

        var addOutcome = await unifiedCartAddWithRetries(items);
        if (!addOutcome.ok) {
          hideUnifiedCartUpdatingOverlay();
          window.__unifiedCartAddInProgress = false;
          try {
            localStorage.removeItem(STORAGE_KEY);
          } catch (_) { /* ignore */ }
          console.error('Cart add failed:', addOutcome.result);
          return;
        }

        await unifiedWaitForCartLinePrices(variantIdsForPoll, 20000);
        try {
          sessionStorage.setItem(UNIFIED_CART_SYNC_RELOAD_KEY, '1');
        } catch (_) { /* ignore */ }
        window.location.replace(cleanUrl);
      } catch (error) {
        hideUnifiedCartUpdatingOverlay();
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (_) { /* ignore */ }
        console.error('Error adding items:', error);
        window.__unifiedCartAddInProgress = false;
      }
    } else {
      // Normal cart page visit (no items to add)
      console.log("[Unified] You're on the cart page");
    }
  }
}

// Function to ensure runner is called
function initRunner() {
  console.log('[Unified] initRunner called');
  runner().then(() => {
    // Hide cart properties after runner completes (for cart pages)
    if (window.location.pathname.includes('/cart')) {
      hideCartProperties();
    }
  }).catch(err => console.error('Unified runner error:', err));
}

// Single entry point: run at most once per page load to prevent duplicate cart adds
let initRunnerHasRun = false;
function runOnce() {
  if (initRunnerHasRun) return;
  initRunnerHasRun = true;
  initRunner();
}

if (document.readyState === 'complete') {
  runOnce();
} else {
  window.addEventListener('load', runOnce);
}

var productButtonObserverInstalled = false;
function installProductButtonObserver() {
  if (productButtonObserverInstalled) return;
  if (!document.body) {
    document.addEventListener('DOMContentLoaded', installProductButtonObserver, { once: true });
    return;
  }
  productButtonObserverInstalled = true;
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      replaceWithCustomButton();
    }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Periodic check for dynamically added / remorphed buttons (Tinker Morph)
setInterval(() => {
  if (window.location.pathname.includes('/products/')) {
    const forms = queryProductAddForms();
    forms.forEach(form => {
      if (isRelatedProductCardForm(form)) return;
      const productType = getEnabledProductType(getFormProductId(form) || getPageProductId());
      if (!productType) return;
      const hasCustomButton = form.querySelector(PIXELFLOW_CUSTOM_BTN_SEL);
      if (!hasCustomButton) {
        console.log('[Unified] Enabled product form missing app button, re-inserting');
        replaceWithCustomButton();
      } else {
        markNativeBuyButtonsHidden(form);
      }
    });
  }
}, 2000);

var PIXELFLOW_APP_OVERLAY_ID = 'pixelflow-app-overlay';
var PIXELFLOW_APP_OVERLAY_STYLE_ID = 'pixelflow-app-overlay-style';

function ensurePixelflowAppOverlayStyle() {
  if (document.getElementById(PIXELFLOW_APP_OVERLAY_STYLE_ID)) return;
  var st = document.createElement('style');
  st.id = PIXELFLOW_APP_OVERLAY_STYLE_ID;
  st.textContent = [
    'html.pixelflow-app-open, html.pixelflow-app-open body { overflow: hidden !important; }',
    'html.pixelflow-app-open #fb-root,',
    'html.pixelflow-app-open .fb-customerchat,',
    'html.pixelflow-app-open .fb_dialog,',
    'html.pixelflow-app-open .fb_dialog_content,',
    'html.pixelflow-app-open .fb_iframe_widget,',
    'html.pixelflow-app-open .fb-livechat,',
    'html.pixelflow-app-open iframe[src*="facebook.com"],',
    'html.pixelflow-app-open iframe[src*="facebook.net"],',
    'html.pixelflow-app-open iframe[src*="connect.facebook"],',
    'html.pixelflow-app-open [class*="fb-customer"],',
    'html.pixelflow-app-open [id*="fb-customer"],',
    'html.pixelflow-app-open [class*="facebook-messenger"],',
    'html.pixelflow-app-open [class*="fb-messenger"] {',
    '  display: none !important;',
    '  visibility: hidden !important;',
    '  pointer-events: none !important;',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(st);
}

function hideStoreWidgetsForAppOverlay() {
  ensurePixelflowAppOverlayStyle();
  document.documentElement.classList.add('pixelflow-app-open');
  var nodes = document.querySelectorAll('iframe, a, div, span, button, img');
  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];
    if (el.id === PIXELFLOW_APP_OVERLAY_ID || (el.closest && el.closest('#' + PIXELFLOW_APP_OVERLAY_ID))) continue;
    var haystack = [
      el.src || '',
      el.href || '',
      el.id || '',
      (typeof el.className === 'string' ? el.className : ''),
      el.getAttribute && el.getAttribute('aria-label') || ''
    ].join(' ');
    if (!/facebook|fb-root|fb_dialog|fb-customer|fb_iframe/i.test(haystack)) continue;
    if (el.getAttribute('data-pixelflow-hidden-widget') === '1') continue;
    el.setAttribute('data-pixelflow-hidden-widget', '1');
    el.setAttribute('data-pixelflow-prev-display', el.style.display || '');
    el.style.setProperty('display', 'none', 'important');
  }
}

function restoreStoreWidgetsAfterAppOverlay() {
  document.documentElement.classList.remove('pixelflow-app-open');
  document.querySelectorAll('[data-pixelflow-hidden-widget="1"]').forEach(function (el) {
    var prev = el.getAttribute('data-pixelflow-prev-display');
    el.style.removeProperty('display');
    if (prev) el.style.display = prev;
    el.removeAttribute('data-pixelflow-hidden-widget');
    el.removeAttribute('data-pixelflow-prev-display');
  });
}

function closePixelflowAppOverlay() {
  var overlay = document.getElementById(PIXELFLOW_APP_OVERLAY_ID);
  if (overlay) overlay.remove();
  restoreStoreWidgetsAfterAppOverlay();
}

function openPixelflowAppOverlay(url) {
  closePixelflowAppOverlay();
  hideStoreWidgetsForAppOverlay();

  var iframeContainer = document.createElement('div');
  iframeContainer.id = PIXELFLOW_APP_OVERLAY_ID;
  iframeContainer.style.cssText = [
    'position: fixed',
    'top: 0',
    'left: 0',
    'width: 100%',
    'height: 100%',
    'z-index: 2147483646',
    'background: white'
  ].join(';');

  var iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.cssText = 'width:100%;height:100%;border:none;';
  iframe.setAttribute('allow', 'clipboard-read; clipboard-write');

  iframeContainer.appendChild(iframe);
  document.body.appendChild(iframeContainer);

  // Chat / social widgets often inject after click — hide them again.
  [300, 1000, 2500].forEach(function (ms) {
    setTimeout(function () {
      if (document.getElementById(PIXELFLOW_APP_OVERLAY_ID)) hideStoreWidgetsForAppOverlay();
    }, ms);
  });
}

if (!window.__pixelflowAppOverlayCloseListener) {
  window.__pixelflowAppOverlayCloseListener = true;
  window.addEventListener('message', function (event) {
    var data = event && event.data;
    if (!data) return;
    var type = typeof data === 'string' ? data : data.type;
    if (!type) return;
    var normalized = String(type).toLowerCase();
    if (
      normalized === 'close' ||
      normalized === 'closebuilder' ||
      normalized === 'pixelflow_close' ||
      normalized === 'pixelflow-close' ||
      normalized === 'gangsheet-close' ||
      normalized === 'dtf-close'
    ) {
      closePixelflowAppOverlay();
    }
  });
}

// Event delegation for GangSheet button
function handleGangSheetClick(event) {
  const btn = event.target.closest('.my-custom-add-button');
  if (!btn) return;
  event.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  (async () => {
    try {
      let productId, variantId, quantity = 1;

      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        productId = ShopifyAnalytics.meta.product.id;
        
        if (ShopifyAnalytics.meta.product.selected_or_first_available_variant) {
          variantId = ShopifyAnalytics.meta.product.selected_or_first_available_variant;
        } else if (ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants.length > 0) {
          variantId = ShopifyAnalytics.meta.product.variants[0].id;
        }
      }

      if (!productId) {
        const productInput = form.querySelector('input[name="product-id"], input[name="product_id"], [name="product-id"]');
        if (productInput && productInput.value) productId = productInput.value;
      }

      if (!variantId) {
        const variantInput = form.querySelector('input[name="id"]') || 
                            form.querySelector('input[name="variant_id"]') ||
                            form.querySelector('[name="id"]') ||
                            form.querySelector('input[type="hidden"][name*="variant"]');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }
      }

      if (!variantId && typeof window.Shopify !== 'undefined') {
        if (window.Shopify.selectedVariant) {
          variantId = window.Shopify.selectedVariant;
        }
      }

      if (!variantId && form.dataset && form.dataset.variantId) {
        variantId = form.dataset.variantId;
      }

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10) || 1;
      }

      if (!productId || !variantId) {
        console.error('Missing product or variant information', {
          productId,
          variantId,
          hasShopifyAnalytics: typeof ShopifyAnalytics !== 'undefined',
          formHTML: form.innerHTML.substring(0, 200)
        });
        alert('Unable to open GangSheet builder. Please refresh the page and try again.');
        return;
      }

      const gangsheetUrl = `${GANGSHEETBUILDER_URL}/?productId=${productId}&variantId=${variantId}&shopId=${shopID}&url=${encodeURIComponent(window.location.origin)}&quantity=${quantity}`;
      openPixelflowAppOverlay(gangsheetUrl);
    } catch (err) {
      console.error('Error opening GangSheet builder:', err);
      alert('Unable to open GangSheet builder. Please refresh the page and try again.');
    }
  })();
}

// Event delegation for DTF button
function handleDtfClick(event) {
  const btn = event.target.closest('.dtf-custom-upload-button');
  if (!btn) return;
  event.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  (async () => {
    try {
      let productId, variantId, quantity = 1;

      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        productId = ShopifyAnalytics.meta.product.id;
        
        if (ShopifyAnalytics.meta.product.selected_or_first_available_variant) {
          variantId = ShopifyAnalytics.meta.product.selected_or_first_available_variant;
        } else if (ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants.length > 0) {
          variantId = ShopifyAnalytics.meta.product.variants[0].id;
        }
      }

      if (!productId) {
        const productInput = form.querySelector('input[name="product-id"], input[name="product_id"], [name="product-id"]');
        if (productInput && productInput.value) productId = productInput.value;
      }

      if (!variantId) {
        const variantInput = form.querySelector('input[name="id"]') || 
                            form.querySelector('input[name="variant_id"]') ||
                            form.querySelector('[name="id"]') ||
                            form.querySelector('input[type="hidden"][name*="variant"]');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }
      }

      if (!variantId && typeof window.Shopify !== 'undefined') {
        if (window.Shopify.selectedVariant) {
          variantId = window.Shopify.selectedVariant;
        }
      }

      if (!variantId && form.dataset && form.dataset.variantId) {
        variantId = form.dataset.variantId;
      }

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10) || 1;
      }

      if (!productId || !variantId) {
        console.error('Missing product or variant information', {
          productId,
          variantId,
          hasShopifyAnalytics: typeof ShopifyAnalytics !== 'undefined',
          formHTML: form.innerHTML.substring(0, 200)
        });
        alert('Unable to open DTF uploader. Please refresh the page and try again.');
        return;
      }

      const dtfAppUrl = `${DTF_APP_URL}?productId=${productId}&variantId=${variantId}&shopId=${shopID}&url=${encodeURIComponent(window.location.origin)}&quantity=${quantity}`;
      openPixelflowAppOverlay(dtfAppUrl);
    } catch (err) {
      console.error('Error opening DTF uploader:', err);
      alert('Unable to open DTF uploader. Please refresh the page and try again.');
    }
  })();
}

// Event delegation for Upload GangSheet button
function handleUgsClick(event) {
  const btn = event.target.closest('.ugs-custom-upload-button');
  if (!btn) return;
  event.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  (async () => {
    try {
      let productId, variantId, quantity = 1;

      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        productId = ShopifyAnalytics.meta.product.id;

        if (ShopifyAnalytics.meta.product.selected_or_first_available_variant) {
          variantId = ShopifyAnalytics.meta.product.selected_or_first_available_variant;
        } else if (ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants.length > 0) {
          variantId = ShopifyAnalytics.meta.product.variants[0].id;
        }
      }

      if (!productId) {
        const productInput = form.querySelector('input[name="product-id"], input[name="product_id"], [name="product-id"]');
        if (productInput && productInput.value) productId = productInput.value;
      }

      if (!variantId) {
        const variantInput = form.querySelector('input[name="id"]') ||
          form.querySelector('input[name="variant_id"]') ||
          form.querySelector('[name="id"]') ||
          form.querySelector('input[type="hidden"][name*="variant"]');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }
      }

      if (!variantId && typeof window.Shopify !== 'undefined') {
        if (window.Shopify.selectedVariant) {
          variantId = window.Shopify.selectedVariant;
        }
      }

      if (!variantId && form.dataset && form.dataset.variantId) {
        variantId = form.dataset.variantId;
      }

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10) || 1;
      }

      if (!productId || !variantId) {
        console.error('Missing product or variant information (Upload GangSheet)', {
          productId,
          variantId
        });
        alert('Unable to open Upload GangSheet. Please refresh the page and try again.');
        return;
      }

      const ugsUrl = `${UPLOAD_GANGSHEET_URL}/?productId=${productId}&variantId=${variantId}&shopId=${shopID}&url=${encodeURIComponent(window.location.origin)}&quantity=${quantity}`;
      openPixelflowAppOverlay(ugsUrl);
    } catch (err) {
      console.error('Error opening Upload GangSheet:', err);
      alert('Unable to open Upload GangSheet. Please refresh the page and try again.');
    }
  })();
}

// Attach event listeners
document.addEventListener('click', handleGangSheetClick);
document.addEventListener('click', handleDtfClick);
document.addEventListener('click', handleUgsClick);

// ── Upload GangSheet cart helpers (broader theme selectors — e.g. Prestige Cart__ItemList) ──
var UGS_CART_LINE_SELECTORS = [
  '.cart__item',
  '.cart-item',
  '[data-line-item]',
  '.Cart__Item',
  '.CartItem',
  '.cart__row',
  '.cart-row',
  'form[action*="/cart"] tbody tr',
  '.Cart tr',
  '.Cart__ItemList tr',
  '.template-cart form tr',
  '.cart-items > .cart-item',
  '.Cart__ItemList > .Cart__Item',
  '.Cart__ItemList > *:not(.Cart__Head)'
];

function isLikelyUploadGangsheetCartLine(el) {
  if (!el || !el.querySelector) return false;
  if (el.classList && (el.classList.contains('Cart__Head') || el.classList.contains('cart__header'))) {
    return false;
  }
  return !!(
    el.querySelector('[name="updates[]"]') ||
    el.querySelector('a[href*="/products/"]') ||
    el.querySelector('.cart-item__name, .CartItem__Title, .Cart__Item__Title, .cart__item-title, .CartItem__Info, .Cart__Item__Info')
  );
}

function queryUploadGangsheetCartLineElements() {
  var seen = [];
  var out = [];
  function pushLine(el) {
    if (!el || seen.indexOf(el) !== -1) return;
    if (!isLikelyUploadGangsheetCartLine(el)) return;
    seen.push(el);
    out.push(el);
  }

  UGS_CART_LINE_SELECTORS.forEach(function (sel) {
    try {
      document.querySelectorAll(sel).forEach(pushLine);
    } catch (_) { /* ignore invalid selectors */ }
  });

  // Fallback for table / legacy themes: walk up from each quantity input to the row wrapper.
  if (!out.length) {
    document.querySelectorAll('[name="updates[]"]').forEach(function (input) {
      var row = input.closest('tr, .Cart__Item, .cart__item, .cart-item, [data-line-item]');
      if (!row) {
        row = input.parentElement;
        while (row && row !== document.body) {
          if (row.querySelector && row.querySelector('a[href*="/products/"]')) break;
          row = row.parentElement;
        }
      }
      pushLine(row);
    });
  }

  return out;
}

function findUploadGangsheetCartLineElement(cartItem, cartItemEls, index) {
  if (cartItemEls.length === 1) return cartItemEls[0];
  if (cartItemEls[index]) return cartItemEls[index];
  var key = cartItem.key || '';
  if (key) {
    for (var i = 0; i < cartItemEls.length; i++) {
      var qtyInput = cartItemEls[i].querySelector('[name="updates[]"]');
      if (!qtyInput) continue;
      var dataId = qtyInput.getAttribute('data-id') || '';
      var inputId = qtyInput.id || '';
      if (dataId === key || inputId === 'cart_updates_' + key) {
        return cartItemEls[i];
      }
    }
  }
  var vid = String(cartItem.variant_id || '');
  if (vid) {
    for (var j = 0; j < cartItemEls.length; j++) {
      if ((cartItemEls[j].innerHTML || '').indexOf(vid) !== -1) {
        return cartItemEls[j];
      }
    }
  }
  return null;
}

function getUploadGangsheetProductColumn(el) {
  return el.querySelector(
    '.cart-item__details, .cart__item-details, .cart-item__info, .cart-item__column, ' +
    '[data-product-info], .Cart__Item__Info, .CartItem__Info, .CartItem__Meta, ' +
    '.Cart__Item__Meta, .cart__item-title-and-variant, .cart__item__info'
  ) || el.children[0] || el;
}

function extractUploadGangsheetKeyFromItem(item) {
  var props = (item && item.properties) || {};
  var key = String(props.uploadGangsheetKey || '').trim();
  if (key) return key;
  var variantText = String(item.variant_title || item.title || '').trim();
  var match = variantText.match(/(upload-gangsheet\/[^\s·]+|gangsheet\/[^\s·]+\.(?:png|jpe?g|webp|gif|pdf|svg))/i);
  return match ? match[1] : '';
}

function isWrongUploadGangsheetAppUrl(url) {
  if (!url) return true;
  var lower = String(url).toLowerCase();
  return lower.indexOf('gangsheetbuilder') !== -1 || lower.indexOf('/load?canvasid=') !== -1;
}

function isUploadGangsheetCartItem(item) {
  if (!item) return false;
  var props = item.properties || {};
  // GangSheet builder and DTF-by-size always carry their own ids — never upload gangsheet.
  if (props.canvasId || props.dtfbysizesheetId) return false;
  // Trust explicit upload-gangsheet line-item markers (do not gate on product list — stale lists broke previews).
  return !!(
    props.uploadGangsheetKey ||
    props._upload_gs_file_url ||
    props._upload_gs_preview_url ||
    extractUploadGangsheetKeyFromItem(item)
  );
}

function resolveUploadGangsheetUrls(item) {
  var props = (item && item.properties) || {};
  var fileUrl = String(props._upload_gs_file_url || '').trim();
  var previewUrl = String(props._upload_gs_preview_url || '').trim();
  var uploadKey = extractUploadGangsheetKeyFromItem(item);

  if (isWrongUploadGangsheetAppUrl(fileUrl)) fileUrl = '';
  if (isWrongUploadGangsheetAppUrl(previewUrl)) previewUrl = '';

  if (uploadKey) {
    var normalizedKey = uploadKey.replace(/^\/+/, '');
    if (normalizedKey.indexOf('upload-gangsheet/') === 0 || normalizedKey.indexOf('gangsheet/') === 0) {
      ['dtfgangsheet-prod', 'dtfgangsheet-dev'].forEach(function (bucket) {
        var bucketUrl = 'https://' + bucket + '.s3.amazonaws.com/' + normalizedKey;
        if (!fileUrl) fileUrl = bucketUrl;
        if (!previewUrl) previewUrl = bucketUrl;
      });
    }
  }

  return { fileUrl: fileUrl, previewUrl: previewUrl, uploadKey: uploadKey };
}

function shouldHideUploadGangsheetCartRow(text) {
  var normalized = (text || '').toLowerCase().trim();
  if (!normalized || normalized.length > 220) return false;
  // Only upload-gangsheet metadata — do not hide canvasId / gangsheet-builder portalURL rows.
  return (
    normalized.indexOf('uploadgangsheetkey') !== -1 ||
    normalized.indexOf('upload gangsheet key') !== -1 ||
    normalized.indexOf('_upload_gs_file_url') !== -1 ||
    normalized.indexOf('upload_gs_file_url') !== -1 ||
    normalized.indexOf('_upload_gs_preview_url') !== -1 ||
    normalized.indexOf('upload_gs_preview_url') !== -1 ||
    normalized.indexOf('_upload_gs_dimensions') !== -1 ||
    normalized.indexOf('upload_gs_dimensions') !== -1 ||
    normalized.indexOf('_upload_gs_price_display') !== -1 ||
    normalized.indexOf('upload_gs_price_display') !== -1 ||
    normalized.indexOf('upload-gangsheet/') !== -1 ||
    (normalized.indexOf('gangsheet/') !== -1 && /\.(png|jpe?g|webp|gif|pdf|svg)\b/i.test(normalized)) ||
    (normalized.indexOf('portalurl') !== -1 && normalized.indexOf('upload-gang') !== -1)
  );
}

/** Only hide leaf property nodes — never wrapper divs (Prestige aggregates child text and breaks the row). */
function isUploadGangsheetPropertyElement(el) {
  if (!el || !el.tagName) return false;
  if (el.closest && el.closest('.ugs-cart-preview')) return false;
  if (el.matches && el.matches('a[href*="/products/"], img, input, button, select, textarea, label')) return false;
  if (el.querySelector && el.querySelector('a[href*="/products/"], [name="updates[]"], input, button, .js-qty, .Cart__Item__Image, .cart-item__image')) {
    return false;
  }
  var tag = el.tagName.toLowerCase();
  if (tag === 'div') {
    return !!(el.classList && (
      el.classList.contains('cart__property') ||
      el.classList.contains('product-option') ||
      el.classList.contains('CartItem__Property')
    ));
  }
  if (tag === 'li' || tag === 'dd' || tag === 'dt') return true;
  if (tag === 'p' || tag === 'span') return el.children.length === 0;
  return !!(el.classList && (
    el.classList.contains('product-option') ||
    el.classList.contains('cart__property') ||
    el.classList.contains('Cart__Item__Property') ||
    el.classList.contains('CartItem__Property')
  ));
}

function cleanupUploadGangsheetVariantText(node, cleanSize) {
  if (!node) return;
  var txt = (node.textContent || '').trim();
  if (txt.indexOf('upload-gangsheet/') === -1 && !(txt.indexOf(' · ') !== -1 && txt.length > 80)) return;
  if (cleanSize) {
    node.textContent = cleanSize;
    return;
  }
  var match = txt.match(/(\d+\.?\d*\s*[x×]\s*\d+\.?\d*[^·]*)/i);
  if (match) node.textContent = match[1].replace(/\s+/g, ' ').trim();
}

function cleanupUploadGangsheetCartLineText(el, cleanSize) {
  if (!el) return;
  el.querySelectorAll(
    '.product-option dd, dl dd, .cart-item__variant, .cart__item-properties li, ' +
    '.Cart__Item__Variant, .CartItem__Variant, .CartItem__Property, .Cart__Item__Property'
  ).forEach(function (node) {
    cleanupUploadGangsheetVariantText(node, cleanSize);
  });
  el.querySelectorAll('p, span').forEach(function (node) {
    if (node.children.length > 0) return;
    cleanupUploadGangsheetVariantText(node, cleanSize);
  });
}

// Hide cart properties (internal keys and raw DTF-by-size props; DTF image breakdown is shown via renderDtfBySizeCartDisplay)
function hideCartProperties() {
  const propertyLabels = document.querySelectorAll('.cart__item, .cart-item');
  propertyLabels.forEach(item => {
    const propertyRows = item.querySelectorAll('li, .cart__property, .product-option');
    propertyRows.forEach(row => {
      const text = (row.textContent || '').toLowerCase();
      const isUploadGsRow =
        text.includes('portalurl') || text.includes('portal url') ||
        text.includes('_upload_gs_file_url') || text.includes('upload_gs_file_url') ||
        text.includes('_upload_gs_preview_url') || text.includes('upload_gs_preview_url') ||
        text.includes('_upload_gs_dimensions') || text.includes('upload_gs_dimensions') ||
        text.includes('_upload_gs_price_display') || text.includes('upload_gs_price_display');
      if (text.includes('unique_key') || text.includes('created at') ||
          text.includes('dtfbysizesheetid') || text.includes('dtfbysizesheet id') ||
          text.includes('_dtfbysize_images') || text.includes('dtfbysize images') ||
          text.includes('uploadgangsheetkey') || text.includes('upload gangsheet key') ||
          isUploadGsRow) {
        row.style.display = 'none';
      }
    });
  });

  // Upload GangSheet only: Prestige and other themes render properties as plain p/div blocks.
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      var cartItemEls = queryUploadGangsheetCartLineElements();
      cart.items.forEach(function (cartItem, i) {
        if (!isUploadGangsheetCartItem(cartItem)) return;
        var el = findUploadGangsheetCartLineElement(cartItem, cartItemEls, i);
        if (!el) return;
        el.querySelectorAll('li, .cart__property, .product-option, p, span, dt, dd').forEach(function (row) {
          if (!isUploadGangsheetPropertyElement(row)) return;
          var text = (row.textContent || '').toLowerCase();
          if (
            text.indexOf('unique_key') !== -1 ||
            text.indexOf('created at') !== -1 ||
            shouldHideUploadGangsheetCartRow(row.textContent || '')
          ) {
            row.style.display = 'none';
          }
        });
      });
    })
    .catch(function () {});
}

// Render DTF-by-size image breakdown on cart (Image1: 2.4 x 3.6 (Qty:4), Image1Url: s3 url, ...)
function renderDtfBySizeCartDisplay() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      const cartItemEls = document.querySelectorAll('.cart__item, .cart-item, [data-line-item]');
      cart.items.forEach(function (item, i) {
        const raw = item.properties && (item.properties._dtfbysize_images || item.properties['_dtfbysize_images']);
        if (!raw) return;
        const el = cartItemEls[i];
        if (!el) return;
        let container = el.querySelector('.dtfbysize-cart-display');
        if (container) return;
        container = document.createElement('div');
        container.className = 'dtfbysize-cart-display';
        container.style.cssText = 'margin-top:8px;font-size:13px;line-height:1.5;white-space:pre-wrap;word-break:break-word;';
        let images;
        try {
          images = JSON.parse(raw);
        } catch (e) {
          images = null;
        }
        if (Array.isArray(images) && images.length > 0) {
          images.forEach(function (im, idx) {
            const w = im.w != null ? Number(im.w) : 0;
            const h = im.h != null ? Number(im.h) : 0;
            const qty = im.qty != null ? Number(im.qty) : 1;
            const url = (im.url || '').trim();
            const line1 = document.createElement('div');
            line1.textContent = 'Image' + (idx + 1) + ': ' + w.toFixed(1) + ' x ' + h.toFixed(1) + ' (Qty:' + qty + ')';
            line1.style.marginBottom = '2px';
            container.appendChild(line1);
            if (url) {
              const line2 = document.createElement('div');
              line2.textContent = 'Image' + (idx + 1) + 'Url: ' + url;
              line2.style.marginBottom = '6px';
              line2.style.wordBreak = 'break-all';
              line2.style.fontSize = '12px';
              line2.style.color = '#666';
              container.appendChild(line2);
            }
          });
        } else {
          container.textContent = raw;
        }
        // Insert in PRODUCT column (left), below Size — try common theme selectors, then first column/child
        const productCol = el.querySelector('.cart-item__details, .cart__item-details, .cart-item__info, .cart-item__column, [data-product-info]') || el.children[0];
        if (productCol) {
          productCol.appendChild(container);
        } else {
          el.appendChild(container);
        }
      });
    })
    .catch(function () {});
}

/** Upload GangSheet only: replace long variant/path text with readable size, hide raw URLs, show thumbnail linking to full file (s3). */
function renderUploadGangsheetCartDisplay() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      const cartItemEls = queryUploadGangsheetCartLineElements();
      cart.items.forEach(function (item, i) {
        const el = findUploadGangsheetCartLineElement(item, cartItemEls, i);
        if (!el) return;

        if (!isUploadGangsheetCartItem(item)) {
          var strayPreview = el.querySelector('.ugs-cart-preview');
          if (strayPreview) strayPreview.remove();
          return;
        }

        const props = item.properties || {};
        const resolved = resolveUploadGangsheetUrls(item);
        const fileUrl = resolved.fileUrl;
        const previewUrl = resolved.previewUrl;
        if (!fileUrl && !previewUrl) return;

        const cleanSize = (props._upload_gs_size || '').trim();
        cleanupUploadGangsheetCartLineText(el, cleanSize);

        var href = fileUrl || previewUrl;
        var imgSrc = previewUrl || fileUrl;
        if (!href || !imgSrc) return;

        var container = el.querySelector('.ugs-cart-preview');
        if (!container) {
          container = document.createElement('div');
          container.className = 'ugs-cart-preview';
          container.style.cssText = 'margin-top:10px;clear:both;';
          var link = document.createElement('a');
          link.href = href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.setAttribute('aria-label', 'Open original upload file');
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = 'Upload preview';
          img.loading = 'lazy';
          img.onerror = function () {
            if (img.dataset.fallbackTried === '1') return;
            img.dataset.fallbackTried = '1';
            if (fileUrl && img.src !== fileUrl) img.src = fileUrl;
          };
          img.style.cssText = 'max-width:160px;max-height:160px;border-radius:8px;border:1px solid #e5e5e5;display:block;object-fit:contain;vertical-align:top;';
          link.appendChild(img);
          container.appendChild(link);
          var host =
            el.querySelector('.Cart__Item__Info, .CartItem__Info, .cart-item__details, .cart__item-details') ||
            getUploadGangsheetProductColumn(el);
          host.appendChild(container);
        } else {
          var existingImg = container.querySelector('img');
          if (existingImg && existingImg.src !== imgSrc) existingImg.src = imgSrc;
        }
      });
    })
    .catch(function () {});
}

// Run on cart page
if (window.location.pathname.includes('/cart')) {
  function runUploadGangsheetCartPageUi() {
    hideCartProperties();
    renderUploadGangsheetCartDisplay();
  }
  runUploadGangsheetCartPageUi();
  renderDtfBySizeCartDisplay();
  [300, 900, 2000].forEach(function (ms) {
    setTimeout(runUploadGangsheetCartPageUi, ms);
  });
  const observer = new MutationObserver(function () {
    hideCartProperties();
    renderDtfBySizeCartDisplay();
    renderUploadGangsheetCartDisplay();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
